/**
 * The model for the Retail /Locale/:id REST endpoint
 */
import Format from 'app/src/data/Format';
import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class Locale extends RetailModel {
  // Server uses the optionID field as the model's unique identifier. This
  // informs the Backbone.Model of this fact.
  get idAttribute() {
    return 'localeID';
  }

  get defaults() {
    return {
      name: '',
      country: '',
      states: '',
      currencySymbol: '',
      currencyCode: '',
      currencyPrecision: 0,
      languageTag: '',
      dateFormat: '',
      dateTimeFormat: '',
      taxName1: '',
      taxName2: '',
    };
  }

  /**
   * Return the url for the Sale endpoint
   */
  url() {
    let URL = URLHelper.getURL('/Locale');
    if (!this.isNew()) {
      URL += `/${this.id}`;
    }
    return `${URL}.json`;
  }

  /**
   * Overridden to parse out the superfluous json that the LSCloud returns us
   * @param response - the json object returned from the fetch call before this object has initialized from it
   * @returns {*} the json object that this object will initialize itself from
   */
  parse(response) {
    let parsedResponse;
    // trim out wonky stuff from the response which is present if we fetch a single model
    // but not if it's coming from a collection
    if (response.Locale) {
      parsedResponse = response.Locale;
    } else {
      parsedResponse = response;
    }

    return parsedResponse;
  }
}
